import { graphierQL } from 'utils'

import {
  Search_Tags_Sort,
  SearchTagsQuery,
  SearchTagsQueryVariables,
  Tag_Types
} from '~map-search/types/__generated/gql/graphql'

const searchTags = async ({
  from,
  size = 10,
  query,
  types = [
    Tag_Types.Category,
    Tag_Types.CoverageArea,
    Tag_Types.FeatureType,
    Tag_Types.Topic
  ],
  sort = Search_Tags_Sort.Name
}: SearchTagsQueryVariables) => {
  const data = await graphierQL<SearchTagsQuery, SearchTagsQueryVariables>({
    query: searchTagQuery,
    variables: {
      from,
      size,
      query,
      types: types as SearchTagsQueryVariables['types'],
      sort
    }
  })
  return data?.searchTags
}

const searchTagQuery = /* GraphQL */ `
  query SearchTags(
    $from: Int
    $size: Int
    $query: String
    $types: [TAG_TYPES!]
    $sort: SEARCH_TAGS_SORT
  ) {
    searchTags(
      from: $from
      size: $size
      query: $query
      types: $types
      sort: $sort
    ) {
      items {
        id
        name
        count
        description
        type
      }
      total
    }
  }
`
export { searchTagQuery, searchTags }
